import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

const __html = require("./static-miniapp-renderer-view.js").default;

const MiniAppRendererView = ({ location }) => {
    const [isReplaced, setIsReplaced] = useState(false);
    const [template, setTemplate] = useState({});

    useEffect(() => {
        const miniappUrl = location.search?.split("?miniapp=")[1];
        const editedTemplate = __html.replace("$$MINIAPP_URL$$", miniappUrl);

        setTemplate({ __html: editedTemplate });
        setIsReplaced(true);
    }, []);

    return (
        isReplaced && (
            <div className="screen-share">
                <span dangerouslySetInnerHTML={template} />
            </div>
        )
    );
};

MiniAppRendererView.proptypes = {
    location: PropTypes.object,
    search: PropTypes.string
};

export default MiniAppRendererView;
